import { BaseStore, PageStore } from '@stores'

type PageStore = /*unresolved*/ any

export default abstract class Activity extends BaseStore {
  public meta: any;
  public pageStore: PageStore;
  private beforeRender?: Function;
  public globalConfig?: any;

  constructor(props: any) {
    super(props)
    const { meta, query, history, params, bRunInDesigner } = props
    if(!bRunInDesigner){
      this.setGlobalConfig(query)
    }
    this.pageStore = new PageStore({
      bRunInDesigner,
      query,
      params,
      enumData: meta?.enumData,
      userDefines: meta?.userDefines,
      multiData: meta?.multiData,
      history,
      rootStore: this
    })
  }
  setGlobalConfig(query: any) {
    const { closeBeforeRender } = query
    this.globalConfig = new Proxy({ ...__$ynf?.globalConfig, closeBeforeRender}, {
      set: function (_target, property: string) {
        console.error(`Cannot modify ${property}. globalConfig is read-only.`);
        return true; // 阻止写入操作
      },
    });
  }
  addBeforeRender(fn: Function) {
    this.beforeRender = fn
  }
  onBeforeRender(meta: any) {
    return this.globalConfig?.closeBeforeRender ? meta : this.beforeRender?.(meta)
  }
}
